module.exports = __webpack_public_path__ + "img/lebensmittel_agrarwirtschaft.0a9d01b.svg";